/**
 * xミリ秒スリープ
 */
export function sleep(ms) {
  return new Promise(r => {
    setTimeout(() => r(), ms)
  })
}
